import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password.component';
import { LoginComponent } from './components/auth/login/login.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { SignupComponent } from './components/auth/signup/signup.component';
import { CantabPlayComponent } from './components/cantab/cantab-play/cantab-play.component';
import { CantabViewComponent } from './components/cantab/cantab-view/cantab-view.component';
import { CompleteComponent } from './components/complete/complete.component';
import { DccsBorderComponent } from './components/dccs/dccs-border/dccs-border.component';
import { DccsPostComponent } from './components/dccs/dccs-post/dccs-post.component';
import { DccsPreComponent } from './components/dccs/dccs-pre/dccs-pre.component';
import { DccsViewComponent } from './components/dccs/dccs-view/dccs-view.component';
import { HomeComponent } from './components/home/home.component';
import { StroopCongruentComponent } from './components/stroop/stroop-congruent/stroop-congruent.component';
import { StroopIncongruentComponent } from './components/stroop/stroop-incongruent/stroop-incongruent.component';
import { StroopViewComponent } from './components/stroop/stroop-view/stroop-view.component';
import { WppsiProcessingSpeedIndexComponent } from './components/wppsi/wppsi-processing-speed-index/wppsi-processing-speed-index.component';
import { WppsiViewComponent } from './components/wppsi/wppsi-view/wppsi-view.component';
import { WppsiVisualSpatialIndexComponent } from './components/wppsi/wppsi-visual-spatial-index/wppsi-visual-spatial-index.component';
import { AfterLoginGuard, BeforeLoginGuard } from './services/guard.service';

const routes: Routes = [
    { path: '', redirectTo: '/home', pathMatch: 'full', data: { title: 'Home' } },
    { path: 'login', component: LoginComponent, canActivate: [BeforeLoginGuard], data: { title: 'Login' } },
    { path: 'signup', component: SignupComponent, canActivate: [BeforeLoginGuard], data: { title: 'Daftar' } },
    { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [BeforeLoginGuard], data: { title: 'Lupa Password' } },
    { path: 'reset-password/:key', component: ResetPasswordComponent, canActivate: [BeforeLoginGuard], data: { title: 'Reset Password' } },
    { path: 'home', component: HomeComponent, canActivate: [AfterLoginGuard], data: { title: 'Home' } },
    {
        path: 'dccs', canActivate: [AfterLoginGuard],
        children: [
            { path: '', component: DccsViewComponent, data: { title: 'DCCS' } },
            { path: 'pre', component: DccsPreComponent, data: { title: 'DCCS Pre-Switch' } },
            { path: 'post', component: DccsPostComponent, data: { title: 'DCCS Post-Switch' } },
            { path: 'border', component: DccsBorderComponent, data: { title: 'DCCS Border Phase' } },
        ]
    },
    {
        path: 'stroop', canActivate: [AfterLoginGuard],
        children: [
            { path: '', component: StroopViewComponent, data: { title: 'STROOP Test' } },
            { path: 'congruent', component: StroopCongruentComponent, data: { title: 'STROOP Congruent' } },
            { path: 'incongruent', component: StroopIncongruentComponent, data: { title: 'STROOP Incongruent' } },
        ]
    },
    {
        path: 'wppsi', canActivate: [AfterLoginGuard],
        children: [
            { path: '', component: WppsiViewComponent, data: { title: 'WPPSI' } },
            { path: 'visual-spatial-index', component: WppsiVisualSpatialIndexComponent, data: { title: 'WPPSI Visual Spatial' } },
            { path: 'processing-speed-index', component: WppsiProcessingSpeedIndexComponent, data: { title: 'WPPSI Processing Speed' } },
        ]
    },
    {
        path: 'cantab', canActivate: [AfterLoginGuard],
        children: [
            { path: '', component: CantabViewComponent, data: { title: 'CANTAB Test' } },
            { path: 'play', component: CantabPlayComponent, data: { title: 'CANTAB Test' } },
        ]
    },
    {
        path: 'finish', canActivate: [AfterLoginGuard],
        children: [
            { path: '', component: CompleteComponent, data: { title: 'Finish' } }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
